import { useCms } from "@/contexts/CmsContext";
import { Eye, X } from "lucide-react";

export default function PreviewBanner() {
  const { isPreview } = useCms();

  if (!isPreview) return null;

  return (
    <div
      data-testid="preview-banner"
      className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-2"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-sm font-body font-medium">
        <Eye className="w-4 h-4" />
        <span>Mode prévisualisation — Vous voyez les brouillons non publiés</span>
        <a
          href={window.location.pathname}
          className="ml-3 underline text-white/90 hover:text-white text-xs"
        >
          Quitter la prévisualisation
        </a>
      </div>
    </div>
  );
}
